import { SelfServiceGate } from '@/lib/self-service/components/SelfServiceGate';
import { SelfServiceSetupFlow } from '@/lib/self-service/components/SelfServiceSetupFlow';

export default function SetupPage() {
  return (
    <SelfServiceGate requireAuth>
      <SelfServiceSetupFlow />
    </SelfServiceGate>
  );
}
